import { render, staticRenderFns } from "./VideoFormBox.vue?vue&type=template&id=6f9c6e1e"
import script from "./VideoFormBox.vue?vue&type=script&lang=js"
export * from "./VideoFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./VideoFormBox.vue?vue&type=style&index=2&id=6f9c6e1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports